enum ApprovalStatusEnum {
    Approved = 'APPROVED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Legacy = 'LEGACY',
}

export default ApprovalStatusEnum;
